import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import { getReturnRefundByDayData, handleLoader } from '../../../redux/actions/ReturnRefundByDayAction';
// import { getReturnRefundByMonthData, handleLoader } from '../../../redux/actions/ReturnRefundByMonthAction';
import ShowBySelectedCategory from './ShowBySelectedCategory';
import ViewReturnRefundReportModal from './ViewReturnRefundReportModal';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../utils/helpers';
import {
    tableHeaderDataReturnRefund as tableHeaderData, filterShowWise, months,
    vendorNameMapping,filterShowDayMonth
} from '../helper';


const ReturnRefund = ({ dispatch, rtl }) => {

    const location = useLocation();

    const [currentYear, currentMonth] = moment().format('YYYY-MMM').split('-');
    const [prevYear, prevMonth] = moment().subtract(1, 'months').format('YYYY-MMM').split('-');


    const { returnRefundByDayData, salesChannelFilterData, isLoading } = useSelector(
        ({ ReturnRefundByDayReducer,ReturnRefundByMonthReducer, marketPlaceReducer }) =>
        ({
            returnRefundByDayData: ReturnRefundByDayReducer?.returnRefundByDayData,
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            isLoading: ReturnRefundByDayReducer?.isLoading
        })
    );

    const [dataToShow, setDataToShow] = useState(returnRefundByDayData?.modal?.data?.[0]?.yearlySales);
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
    const [currentlyTypeShow, setCurrentlyTypeShow] = useState(filterShowDayMonth?.[0])
    const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
    const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth })
    const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth })

    const yearOptions = [];
    for (let year = 2016; year <= currentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    const monthOptions = months.map(item => ({ label: item, value: item }));

    const date1 = `${month1?.year}-${month1?.month}`;
    const date2 = `${month2?.year}-${month2?.month}`;

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }

        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Return Refund By ${currentlyTypeShow?.label} Report ${new Date().getFullYear()}`,
    })
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            dispatch(handleLoader(true));
            dispatch(getReturnRefundByDayData({ from: tempMonth2?.year, to: month1.year, 
                type: currentlyTypeShow?.value }));
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select maximum one year data'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {

        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value });
        }
    }

    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="12" md="4" >
            <Row className="justify-content-space-between">
                <Col md="5" sm="6">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">{isFrom ? 'Previous' : 'Current'} Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col md="5" sm="6">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>

            </Row>

        </Col>
    );

    const changeFilter = (value) => {
        setCurrentlyShow(value)
    };

    const changeTypeFilter = (value) => {
        setCurrentlyTypeShow(value)
    };

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(getReturnRefundByDayData({ from: currentYear, to: currentYear, type: currentlyTypeShow?.value}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDataToShow(returnRefundByDayData?.modal?.data?.[0]?.yearlySales);
    }, [returnRefundByDayData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    let dataToShowForDatesSelected = [];

    const monthsBetweenDates = findMonthsBetweenDates(date1, date2);

    for (let i = 0; i < monthsBetweenDates.length; i += 1) {
        const [year, month] = monthsBetweenDates?.[i]?.split('-');
        let currentMonthData = dataToShow?.[year]?.monthlyProductSales?.[month] ?? [];

        if (currentMonthData) {
            currentMonthData = currentMonthData.filter(item =>
                filterBasedOnFilter(item))?.map(item => ({
                    ...item,
                    day: Number(item.day).toFixed(0),
                    salesMonth: month,
                    salesYear: year
                }))
            dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(currentMonthData);
        }
    }

    const modalData = dataToShowForDatesSelected?.map(item => ({
        ...item,
        refundOrderCount: setCurrencyFormat(Number(item.refundOrderCount).toFixed(2), true),
        day: Number(item.day).toFixed(0),
        orderCount: setCurrencyFormat(Number(item.orderCount).toFixed(0), false),
    }));

    return (
        <Container className="dashboard">
            <Row className="compare-months">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    Return Refund</h5>
                            </div>
                            <Row className="justify-content-space-between align-items-center">
                                <Col sm="6" md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Show</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={currentlyShow}
                                                options={filterShowWise}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter-show-based"
                                                onChange={value => changeFilter(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="12" md="10">
                                    <Row className="justify-content-right align-items-center ">
                                        <RenderYearAndMonth isFrom />
                                        <Col sm='1' className="filter-to-position">~</Col>
                                        <RenderYearAndMonth />
                                        {/* <Col sm="2" md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Type</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={currentlyTypeShow}
                                                options={filterShowDayMonth}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter-show-based"
                                                onChange={value => changeTypeFilter(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col> */}
                                        <Col sm="3" className="p-0 filter-to-position">
                                            <button className="btn btn-sm btn-primary
                                             apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button> 
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>                                       
                                    </Row>
                                </Col>
                                <Col sm="12" md="12">
                                <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Type</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={currentlyTypeShow}
                                                options={filterShowDayMonth}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter-show-based"
                                                onChange={value => changeTypeFilter(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

            </Row>
            <div id="divToPrint" ref={container}>
            <Row className="show-categ-day-wise-sales">
                <Col xs="12">
                    <Card className="pb-3 show-categ-daily-sales">
                        <CardBody>
                            {isLoading ? (
                                <>
                                    <div className="card__title">
                                        <h5 className="bold-text">
                                            {`Return Refund by 
                                            ${currentlyTypeShow?.label} and ${currentlyShow?.label}`}</h5>
                                    </div>
                                    <div
                                        style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center"
                                    >
                                        <SmallLoader loading={isLoading} />
                                    </div>
                                </>) : (
                                <ShowBySelectedCategory
                                    dir={rtl.direction}
                                    dataToShowForDatesSelected={dataToShowForDatesSelected}
                                    height={300}
                                    title={`Return Refund by ${currentlyTypeShow?.label} and ${currentlyShow?.label}`}
                                    viewReportButton={viewReportButton}
                                    categorisedBasedOn={currentlyShow?.value}
                                    currentlyShow={currentlyShow}
                                    currentlyTypeShow={currentlyTypeShow}
                                />)}
                        </CardBody>

                    </Card>
                </Col>
            </Row>
            </div>
            <ViewReturnRefundReportModal
                modalData={modalData}
                isOpen={isOpen}
                handleModal={setIsOpen}
                tableHeaderData={tableHeaderData}
                fileName={`Return Refund by ${currentlyTypeShow?.label} and ${currentlyShow?.label} Report`}
                title={`Return Refund by ${currentlyTypeShow?.label} and ${currentlyShow?.label} Report`}
            />
        </Container>
    );
};

ReturnRefund.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired
};

export default connect(state => ({
    rtl: state.rtl,
}))(ReturnRefund);
